// Mesma normalização usada no back-end (LeadService.isLeadSameAsReferrer)
// para bloquear um player se auto-indicando como lead.

interface ILeadContactData {
  email?: string;
  cpf?: string;
  phone?: string;
}

interface IReferrerContactData {
  email?: string;
  cpf?: string;
  phoneNumber?: string;
  phoneWhatsapp?: string;
}

const normalizeEmail = (value?: string | null): string =>
  value ? String(value).toLowerCase().trim() : '';

const normalizeDocument = (value?: string | null): string =>
  value ? String(value).replace(/\D/g, '') : '';

const normalizePhoneDigits = (value?: string | null): string => {
  if (!value) return '';

  let digits = String(value).replace(/\D/g, '');

  switch (digits.length) {
    case 13: // 55 + DDD + 9 dígitos, já completo
      break;
    case 12: // 55 + DDD + 8 dígitos, falta o 9
      digits = `${digits.slice(0, 4)}9${digits.slice(4)}`;
      break;
    case 11: // DDD + 9 dígitos, falta o 55
      digits = `55${digits}`;
      break;
    case 10: // DDD + 8 dígitos, falta o 55 e o 9
      digits = `55${digits.slice(0, 2)}9${digits.slice(2)}`;
      break;
    default:
      return digits;
  }

  return digits;
};

export const isLeadSameAsPlayer = (
  lead: ILeadContactData,
  player?: IReferrerContactData | null
): boolean => {
  if (!player) return false;

  const leadEmail = normalizeEmail(lead.email);
  if (leadEmail && leadEmail === normalizeEmail(player.email)) return true;

  const leadDocument = normalizeDocument(lead.cpf);
  if (leadDocument && leadDocument === normalizeDocument(player.cpf)) {
    return true;
  }

  const leadPhone = normalizePhoneDigits(lead.phone);
  if (
    leadPhone &&
    (leadPhone === normalizePhoneDigits(player.phoneNumber) ||
      leadPhone === normalizePhoneDigits(player.phoneWhatsapp))
  ) {
    return true;
  }

  return false;
};
